import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GRUPPEN = {
  archiviert: "Archiviert – wird zurückgeholt (mit echter Unterschrift)",
  mit_unterschrift: "Neu erzeugen mit Original-Unterschrift (nachweisbar unterschrieben)",
  ohne_unterschrift: "Neu erzeugen ohne TN-Unterschrift (kein Nachweis)",
  nicht_moeglich: "Nicht möglich – keine Anwesenheitsdaten",
};

export const AlWiederherstellungBlock = () => {
  const [liste, setListe] = useState(null);
  const [wahl, setWahl] = useState(["archiviert", "mit_unterschrift", "ohne_unterschrift"]);
  const [laeuft, setLaeuft] = useState(false);
  const laden = () => axios.get(`${API}/admin/al-wiederherstellung/vorschau`).then((r) => setListe(r.data)).catch(() => toast.error("Vorschau fehlgeschlagen"));
  const anz = (g) => (liste || []).filter((x) => x.gruppe === g).length;
  const los = async () => {
    const n = wahl.reduce((s, g) => s + anz(g), 0);
    if (!window.confirm(`${n} Anwesenheitslisten wiederherstellen?\nArchivierte werden zurückgeholt, fehlende aus dem Klassenbuch neu erzeugt. Teilnehmer-Unterschrift nur bei Original-Nachweis.`)) return;
    setLaeuft(true);
    try {
      for (let i = 0; i < 200; i += 1) {
        const r = await axios.post(`${API}/admin/al-wiederherstellung/ausfuehren`, { bestaetigt: true, gruppen: wahl });
        r.data.fehler.forEach((f) => toast.error(`${f.name}: ${f.grund}`));
        if (!r.data.rest || !r.data.erledigt.length) break;
        toast.message(`Noch ${r.data.rest} …`);
      }
      toast.success("Wiederherstellung abgeschlossen");
      await laden();
    } catch (e) { toast.error(e.response?.data?.detail || "Wiederherstellung fehlgeschlagen"); } finally { setLaeuft(false); }
  };
  return (
    <div className="border rounded-lg p-4 mb-3" data-testid="al-wiederherstellung-block">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="font-medium">Fehlende Anwesenheitslisten wiederherstellen (Kurse ab 2025, ohne Rezi)</p>
          <p className="text-sm text-muted-foreground">Nur Teilnehmende mit beendetem Kurs und ohne Anwesenheitsliste in der Akte.</p>
        </div>
        <Button size="sm" variant="outline" onClick={laden} data-testid="al-wiederherstellung-vorschau">Vorschau</Button>
      </div>
      {liste && (
        <div className="mt-3 text-sm space-y-2">
          {Object.entries(GRUPPEN).map(([g, t]) => (
            <details key={g} data-testid={`al-gruppe-${g}`}>
              <summary className="cursor-pointer">
                {g !== "nicht_moeglich" && <input type="checkbox" className="mr-2" checked={wahl.includes(g)} onClick={(e) => e.stopPropagation()}
                  onChange={(e) => setWahl(e.target.checked ? [...wahl, g] : wahl.filter((x) => x !== g))} data-testid={`al-wahl-${g}`} />}
                <b>{anz(g)}</b> {t}
              </summary>
              <ul className="ml-6 mt-1 max-h-48 overflow-y-auto text-xs text-muted-foreground">
                {liste.filter((x) => x.gruppe === g).map((x) => <li key={x.teilnehmer_id}>{x.name} · {x.kurs} · {x.zeitraum} · {x.detail}</li>)}
              </ul>
            </details>
          ))}
          <Button size="sm" disabled={laeuft || !wahl.length} onClick={los} data-testid="al-wiederherstellung-start">{laeuft ? "Läuft …" : "Ausgewählte wiederherstellen"}</Button>
        </div>
      )}
    </div>
  );
};
